import { useTheme } from '@emotion/react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import moment from 'moment';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import DoneIcon from '@mui/icons-material/Done';

import ShipIcon from '../../../../assets/images/ship.svg';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { useTranslation } from 'react-i18next';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion
    disableGutters
    elevation={0}
    square
    {...props}
  />
))(({ theme }) => ({
  // border: `1px solid ${theme.palette.divider}`,
  // '&:not(:last-child)': {
  //   borderBottom: 0,
  // },
  width: '100%',
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    // marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  // padding: theme.spacing(2),
  // borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function VoyageDetails({ isDrawerOpen, toggleDrawer, data, openEditVoyage, details }) {
  const [expanded, setExpanded] = useState(false);

  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { t } = useTranslation();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Stack className="flex-overflow pt-[16px]">
      <Stack
        direction={'row'}
        className="!mb-[16px]"
      >
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Voyage no.')}
            </Typography>
            {data?.isVerified && (
              <Stack
                style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#00A632' }}
                className="h-[12px] w-[12px] rounded-[6px] ml-[10px] "
              >
                <DoneIcon style={{ color: '#ffffff', transform: 'scale(0.5)' }} />
              </Stack>
            )}
          </Stack>

          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {data?.voyageNo || '-'}
          </Typography>
        </Stack>
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('Voyage ID')}
            </Typography>
          </Stack>

          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {data?.voyageId || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px]"
        alignItems={'center'}
      >
        <Stack flex={0.4}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Voyage from')}
          </Typography>
          <Stack className="mt-[12px]">
            <Typography
              className="fs-14 ff-Roboto fw-medium"
              color={text}
              style={{ maxWidth: '225px' }}
              textTransform={'capitalize'}
            >
              {data?.voyageFrom || '-'}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {moment(data?.fromDate).format('DD-MMM-YYYY')}
            </Typography>
          </Stack>
        </Stack>
        <Stack flex={0.25}>
          <img
            src={ShipIcon}
            style={{ width: '98px', height: '32px' }}
          />
        </Stack>
        <Stack
          flex={0.4}
          alignItems={'center'}
        >
          <Stack>
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Voyage to')}
            </Typography>
            <Stack className="mt-[12px]">
              <Typography
                className="fs-14 ff-Roboto fw-medium"
                color={text}
                style={{ maxWidth: '225px' }}
                textTransform={'capitalize'}
              >
                {data?.voyageTo || '-'}
              </Typography>
              <Typography
                className="fs-12 ff-Roboto fw-medium"
                color={text}
                style={{ maxWidth: '225px' }}
              >
                {moment(data?.toDate).format('DD-MMM-YYYY')}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        style={{}}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Typography
          className="fs-12 ff-Roboto bg-[#ffffff] fw-medium !mb-[-8px] !z-[10] !capitalize"
          color={'#14285A'}
        >
          {t('Ship allowances')}
        </Typography>
      </Stack>
      <Box
        style={{ borderColor: '#14285A26', borderWidth: '1px', borderRadius: '8px' }}
        className="!mx-[8px]"
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          className=""
        >
          <Accordion
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')}
            style={{ margin: '0px' }}
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              flex={1}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                flex={1}
              >
                <Typography
                  sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                  className="fs-14 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {data?.isVerified ? t('Verified EUA Cost') : t('Estimated EUA cost')}
                </Typography>
              </AccordionSummary>
              <Typography
                sx={{ width: '200%', marginRight: '16px' }}
                className="fs-14 ff-Roboto fw-medium"
                color={text}
                flex={1}
                textAlign={'right'}
              >
                €{' '}
                {(data?.isVerified
                  ? parseFloat(data?.totalEuaCost)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : parseFloat(data?.totalEstEuaCost)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })) || '-'}
              </Typography>
            </Stack>

            <AccordionDetails style={{ marginTop: '0px', maxWidth: '300px' }}>
              <Typography
                className="fs-12 ff-Roboto fw-regular !px-[2px]"
                color={textLight}
              >
                {data?.isVerified ? t('Invoice Cost of EUA based on the verified EUA') : t('Estimated cost of the estimated EU Allowances on the basis of the 7-day average spot EUA price')}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Accordion
            expanded={expanded === 'panel2'}
            onChange={handleChange('panel2')}
            style={{ margin: '0px' }}
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                flex={1}
              >
                <Typography
                  sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                  className="fs-14 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {data?.isVerified ? t('Verified EUA Consumed') : t('Estimated EUA required')}
                </Typography>
              </AccordionSummary>
              <Typography
                sx={{ width: '100%', marginRight: '16px' }}
                className="fs-14 ff-Roboto fw-medium"
                color={text}
                flex={1}
                textAlign={'right'}
              >
                {data?.isVerified
                  ? parseFloat(data?.totalEua)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : parseFloat(data?.totalEstEua)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '-'}
              </Typography>
            </Stack>

            <AccordionDetails style={{ marginTop: '0px', maxWidth: '300px' }}>
              <Typography
                className="fs-12 ff-Roboto fw-regular !px-[2px]"
                color={textLight}
              >
                {data?.isVerified ? t('EUA Consumed based on the verified EUA') : t('Estimated EUA required for a voyage based on the estimated fuel consumption')}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Stack>
        {!data?.isVerified && data?.reportStatus !== null && (
          <>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Accordion
                expanded={expanded === 'panel6'}
                onChange={handleChange('panel6')}
                style={{ margin: '0px' }}
              >
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    flex={1}
                  >
                    <Typography
                      sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                      className="fs-14 ff-Roboto fw-regular !capitalize"
                      color={text}
                    >
                      {t('EUA Cost')}
                    </Typography>
                  </AccordionSummary>
                  <Typography
                    sx={{ width: '100%', marginRight: '16px' }}
                    className="fs-14 ff-Roboto fw-medium"
                    color={text}
                    flex={1}
                    textAlign={'right'}
                  >
                    €{' '}
                    {parseFloat(data?.totalEuaCost)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '-'}
                  </Typography>
                </Stack>

                <AccordionDetails style={{ marginTop: '0px', maxWidth: '300px' }}>
                  <Typography
                    className="fs-12 ff-Roboto fw-regular !px-[2px]"
                    color={textLight}
                  >
                    {t('Cost of the EU Allowances based on the 7-day average spot EUA price')}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Accordion
                expanded={expanded === 'panel7'}
                onChange={handleChange('panel7')}
                style={{ margin: '0px' }}
              >
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    flex={1}
                  >
                    <Typography
                      sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                      className="fs-14 ff-Roboto fw-regular !capitalize"
                      color={text}
                    >
                      {t('EUA required')}
                    </Typography>
                  </AccordionSummary>
                  <Typography
                    sx={{ width: '100%', marginRight: '16px' }}
                    className="fs-14 ff-Roboto fw-medium"
                    color={text}
                    flex={1}
                    textAlign={'right'}
                  >
                    {parseFloat(data?.totalEua)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '-'}
                  </Typography>
                </Stack>

                <AccordionDetails style={{ marginTop: '0px', maxWidth: '300px' }}>
                  <Typography
                    className="fs-12 ff-Roboto fw-regular !px-[2px]"
                    color={textLight}
                  >
                    {t('EUA Allowances required for a voyage based on the reported fuel consumption')}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Stack>
          </>
        )}

        <Stack
          className="mt-[32px] mx-[12px] pt-[16px] mb-[12px]"
          style={{ backgroundColor: '#8993AC1A', borderRadius: '4px' }}
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular px-[16px] !capitalize"
            color={text}
          >
            {t('Ship owner')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium  px-[16px]"
            color={text}
          >
            {data?.owner}
          </Typography>
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Accordion
              expanded={expanded === 'panel3'}
              onChange={handleChange('panel3')}
              style={{ margin: '0px' }}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                style={{ backgroundColor: '#8993AC1A' }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  flex={1}
                >
                  <Typography
                    sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                    className="fs-14 ff-Roboto fw-regular !capitalize"
                    color={text}
                  >
                    {t('EUA to surrender')}
                  </Typography>
                </AccordionSummary>
                <Typography
                  sx={{ width: '100%', flexShrink: 0, marginRight: '16px' }}
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  flex={1}
                  textAlign={'right'}
                >
                  {parseFloat(data?.euaToSurrender)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) || '0'}
                </Typography>
              </Stack>

              <AccordionDetails style={{ marginTop: '0px', width: '100%', backgroundColor: '#8993AC1A' }}>
                <Typography
                  className="fs-12 ff-Roboto fw-regular !px-[2px]"
                  color={textLight}
                  style={{ maxWidth: '300px' }}
                >
                  {t('Amount of EUA to be surrendered to Eu by 30th september of next year')}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Accordion
              expanded={expanded === 'panel4'}
              onChange={handleChange('panel4')}
              style={{ margin: '0px' }}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                style={{ backgroundColor: '#8993AC1A' }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  flex={1}
                >
                  <Typography
                    sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                    className="fs-14 ff-Roboto fw-regular !capitalize"
                    color={text}
                  >
                    {t('EUA verified balance')}
                  </Typography>
                </AccordionSummary>
                <Typography
                  sx={{ width: '100%', flexShrink: 0, marginRight: '16px' }}
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  flex={1}
                  textAlign={'right'}
                >
                  {parseFloat(data?.euaVerifiedBalance)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) || '0'}
                </Typography>
              </Stack>

              <AccordionDetails style={{ marginTop: '0px', maxWidth: '100%', backgroundColor: '#8993AC1A' }}>
                <Typography
                  className="fs-12 ff-Roboto fw-regular !px-[2px]"
                  color={textLight}
                  style={{ maxWidth: '300px' }}
                >
                  {t('Running total of balance EU allowances for the current year as of today after deducting the verified EUA consumed in the voyages from the Actual EUA balance')}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Accordion
              expanded={expanded === 'panel5'}
              onChange={handleChange('panel5')}
              style={{ margin: '0px' }}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                style={{ backgroundColor: '#8993AC1A' }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  flex={1}
                >
                  <Typography
                    sx={{ width: '100%', flexShrink: 0, marginTop: '2px' }}
                    className="fs-14 ff-Roboto fw-regular !capitalize"
                    color={text}
                  >
                    {t('EUA balance')}
                  </Typography>
                </AccordionSummary>
                <Typography
                  sx={{ width: '100%', flexShrink: 0, marginRight: '16px' }}
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  flex={1}
                  textAlign={'right'}
                >
                  {parseFloat(data?.euaBalance)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) || '0'}
                </Typography>
              </Stack>

              <AccordionDetails style={{ marginTop: '0px', maxWidth: '100%', backgroundColor: '#8993AC1A' }}>
                <Typography
                  className="fs-12 ff-Roboto fw-regular !px-[2px]"
                  color={textLight}
                  style={{ maxWidth: '300px' }}
                >
                  {t('Running total of balance EU allowances for the current year as of today after deducting the EUA consumed in the voyages from the Actual EUA balance')}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </Stack>
      </Box>
      <Stack
        direction={'row'}
        className="!my-[16px]"
      >
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('IMO number')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {data?.imoNumber || '-'}
          </Typography>
        </Stack>
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Ship name')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {data?.shipName || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="pb-[16px]"
      >
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Ship type')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {data?.shipType || '-'}
          </Typography>
        </Stack>
        <Stack
          flex={0.5}
          className="px-[16px]"
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Ship condition')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px', textTransform: 'capitalize' }}
          >
            {t(data?.shipCondition) || '-'}
          </Typography>
        </Stack>{' '}
      </Stack>
      <Stack>
        <Stack
          direction={'row'}
          className="pb-[16px]"
        >
          <Stack
            flex={0.5}
            className="px-[16px]"
          >
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Summer deadweight')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {(data?.summerDeadWeight && data?.summerDeadWeight?.toLocaleString() + 'mt (metric ton)') || '-'}
            </Typography>
          </Stack>
        </Stack>

        <Stack
          style={{ backgroundColor: '#14285A26', width: '93%', height: '1px' }}
          className="!my-[16px] !mx-[16px]"
        />
      </Stack>

      <Typography
        className="fs-14 ff-Roboto fw-medium !mx-[16px] !mb-[10px]"
        color={text}
      >
        {t('FO consumption as per CP')}
      </Typography>
      <Stack
        style={{ borderWidth: '1px', borderColor: '#14285A26', borderRadius: '8px' }}
        className="mx-[16px]"
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          className="!px-[16px] !mt-[16px]"
        >
          <Stack flex={0.25}>
            <Typography
              className="fs-12 ff-Roboto fw-medium !mb-[16px]"
              color={text}
            >
              {t('Fuel type')}
            </Typography>
          </Stack>

          <Stack flex={0.35}>
            <Typography
              className="fs-12 ff-Roboto fw-medium !capitalize"
              color={text}
            >
              {t('Emission factor')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium !lowercase"
              color={textLight}
            >
              t CO2/ t {t('Fuel')}
            </Typography>
          </Stack>
          <Stack flex={0.25}>
            <Typography
              className="fs-12 ff-Roboto fw-medium !capitalize"
              color={text}
            >
              {t('laden')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium"
              color={textLight}
            >
              C/P
            </Typography>
          </Stack>
          <Stack flex={0.25}>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
            >
              {t('ballast')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium"
              color={textLight}
            >
              C/P
            </Typography>
          </Stack>
        </Stack>
        <Stack
          style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
          className="!my-[16px] !mr-[16px]"
        />
        {data?.fuelUsed?.map((item, index) => (
          <Stack
            direction={'row'}
            alignItems={'center'}
            style={{ marginTop: index > 0 ? '16px' : '0px', paddingBottom: index === data?.fuelUsed?.length - 1 ? '16px' : '0px' }}
            className="!px-[16px]"
          >
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
              flex={0.25}
            >
              {item.fuelType || '-'}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={0.35}
            >
              {item?.emissionFactor || '0'}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={0.25}
            >
              {item?.dailyConsumptionCperPLaden || '0'}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={0.25}
            >
              {item?.dailyConsumptionCperPBallest || '0'}
            </Typography>
          </Stack>
        ))}
      </Stack>
      <Stack flexGrow={1} />
      <Stack
        direction="row"
        alignItems={'flex-end'}
        justifyContent="flex-end"
        className="px-4 p-[0px] sticky bottom-[0] !mt-[40px]"
        // className="!mt-[44px] h-[66px] "
        style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
      >
        {/* <Button
          sx={[
            dialogButtonCancel,
            {
              color: theme.palette.primary.main,
              textTransform: 'uppercase',
              '&:hover': {},
            },
          ]}
          style={{ width: '178px', height: '40px' }}
          onClick={() => {
            // onModelHandleClose(false);
          }}
        >
          {t('Processing report')}...
        </Button> */}
        <Button
          sx={{
            border: 1,
            margin: '10px',
            color: theme.palette.primary.text,
            borderColor: '#14285A4D',
            backgroundColor: '#FFFFFF',
            textTransform: 'uppercase',
            '&:hover': {
              borderColor: '#14285A4D',
              backgroundColor: '#FFFFFF',
              borderColor: '#14285A4D',
            },
          }}
          style={buttonStyle2}
          variant="contained"
          // style={{ width: '128px', marginLeft: '80px', height: '40px', borderColor: '#14285A4D' }}
          onClick={() => {
            openEditVoyage();
          }}
        >
          {t('Edit details')}
        </Button>
      </Stack>
    </Stack>
  );
}
